import moment from 'moment';

function dateToNum(date: any) {
    if (date === undefined || date === null) {
        return null;
    }

    const dateObj = new Date(moment(
        date
    ).format('MM/DD/YYYY'));

    const yearNumber = dateObj.getFullYear();
    const monthNumber = dateObj.getMonth();
    const dayNumber = dateObj.getDate();

    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    // 22/05/2023 => 20230522
    return result;
}

// DATE COMPARATOR FOR SORTING
export function dateComparator(date1: any, date2: any) {
    var date1Number = dateToNum(date1);
    var date2Number = dateToNum(date2);
    if (date1Number === null && date2Number === null) {
        return 0;
    }
    if (date1Number === null) {
        return -1;
    }
    if (date2Number === null) {
        return 1;
    }

    return date1Number - date2Number;
}

export function dateComparatorWithStrDate(date1: any, date2: any) {
    date1 = moment.utc(
        date1,
        'MM/DD/YYYY h:mm:ss A Z');
    date2 = moment.utc(
        date2,
        'MM/DD/YYYY h:mm:ss A Z');
    var date1Number = dateToNum(date1);
    var date2Number = dateToNum(date2);
    if (date1Number === null && date2Number === null) {
        return 0;
    }
    if (date1Number === null) {
        return -1;
    }
    if (date2Number === null) {
        return 1;
    }

    return date1Number - date2Number;
}

export function dateValueFormatterWOTime(date: any) {
    return date ? moment.utc(
        date
    ).local().format('MM/DD/YYYY') : '';
};

export function dateValueFormatter(date: any) {
    return date ? moment.utc(
        date
    ).local().format('MM/DD/YYYY h:mm:ss A Z') : '';
};

export function timeValueFormatter(date: any) {
    return date ? moment.utc(
        date
    ).local().format('h:mm:ss A') : '';
};


export function dateValueFormatterWithHHMM(date: any) {
    return date ? moment.utc(
        date
    ).local().format('MM/DD/YYYY H:mm') : '';
};

export function strToDate(strDate: any) {
    var localStartDate = moment
        .utc(strDate)
        .local()
        .format('MM/DD/YYYY H:mm');
    return new Date(localStartDate);
}

export function formattedTime(dateTime: Date) {
    const hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    const formattedTime = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
    return formattedTime;
}


export const dateTimeComparatorAgGrid = (dateTimeInput: any, cellValue: any) => {
    if (!cellValue) {
        return -1;
    }

    const cellFormattedDate = new Date(cellValue);
    const applyFilter = dateTimeInput;

    const dateInput = new Date(cellFormattedDate.getFullYear(), cellFormattedDate.getMonth(), cellFormattedDate.getDate());

    if (dateInput < applyFilter) {
        return -1;
    }

    if (dateInput > applyFilter) {
        return 1;
    }

    return 0;

}

export const valueFormatterAgGrid = (params: any) => {
    if (!params.value) {
        return;
    }

    const date = new Date(params.value);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
}

export const getLocalizationValues = (currentLocale: string, data: any) => {
    const resolve = (localeObj: any, key: 'enCA' | 'frCA', fallback: any) => {
        if (currentLocale === "en_CA" && localeObj?.enCA) return localeObj.enCA;
        if (currentLocale === "fr_CA" && localeObj?.frCA) return localeObj.frCA;
        return fallback;
    };

    return {
        title: resolve(data.titleLocale, 'enCA', data.title),
        subject: resolve(data.subjectLocale, 'enCA', data.subject),
        body: currentLocale === "en_CA" ? 
            (data.bodyLocale?.enCA && data.bodyLocale?.enCA !== '<br>' ? data.bodyLocale.enCA : data.body) :
            (currentLocale === "fr_CA" ? (data.bodyLocale?.frCA && data.bodyLocale?.frCA !== '<br>' ? data.bodyLocale.frCA : data.body) : data.body),
        externalUrl: resolve(data.externalUrlLocale, 'enCA', data.externalUrl),
    };
};

const resolveLocaleValue = (locale: string, localeObj?: any, fallback?: any) => {
    if (!localeObj || typeof localeObj !== "object")
        return fallback;

    if (locale === "en_CA") {
        return localeObj.enCA && localeObj.enCA !== "" ? localeObj.enCA : fallback;
    }

    if (locale === "fr_CA") {
        return localeObj.frCA && localeObj.frCA !== "" ? localeObj.frCA : fallback;
    }

    return localeObj.enUS && localeObj.enUS !== "" ? localeObj.enUS : fallback;
};

export const getLocalizedValues = (locale: string, data: any, fieldName: string) => {
    const value = data[fieldName];
    if (value && typeof value === "object" && ("enUS" in value || "enCA" in value || "frCA" in value)) {
        return {
            [fieldName]: resolveLocaleValue(locale, value, value.enUS ?? "")
        };
    }
    return { [fieldName]: value };
};

export function dateTimeValueFormatter(date: any) {
    if (!date) return '';
    const m = moment.utc(date);
    return m.isValid() ? m.local().format('MM/DD/YYYY h:mm A') : '';
}